import React from 'react';
import { Link } from 'react-router-dom';

function BlogTile({ post }) {
  // Derive AVIF and WebP paths from the original image path
  const base = post.image.replace(/\.(jpg|jpeg|png)$/i, '');
  const avif = base + '.avif';
  const webp = base + '.webp';
  // Default width/height for blog tile images
  const width = 600;
  const height = 320;
  return (
    <div className="bg-white rounded-lg shadow p-6 flex flex-col h-full">
      <picture>
        <source srcSet={avif} type="image/avif" />
        <source srcSet={webp} type="image/webp" />
      <img 
        src={post.image} 
        alt={post.title} 
          title={`${post.title.length > 45 ? post.title.slice(0, 45).replace(/\s+\S*$/, '') + '…' : post.title} – Copper Canyon Blog`}
        className="w-full h-48 object-cover rounded mb-4 bg-gray-100" 
        style={{objectPosition: 'center'}}
          loading="lazy"
          width={width}
          height={height}
      />
      </picture>
      <Link to={`/blog/${post.slug}`} className="text-2xl font-semibold text-[#b87c4c] mb-2 hover:underline">
        {post.title}
      </Link>
      <p className="text-sm text-[#4a3f35] mb-2">{new Date(post.date).toLocaleDateString()}</p>
      <p className="text-gray-600 mb-4 flex-1">{post.summary}</p>
      <div className="mt-auto pt-2">
      <Link 
        to={`/blog/${post.slug}`} 
        className="inline-block px-4 py-2 bg-[#8B4513] text-white font-medium rounded-lg shadow hover:bg-[#6B3410] transition-colors duration-200"
        aria-label={`Read more about ${post.title}`}
        title={`Read more about ${post.title}`}
      >
        Read More
      </Link>
      </div>
    </div>
  );
}

export default BlogTile; 